/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoodsInfoOrderInfoForInboundPictureVo1
 */
export interface GoodsInfoOrderInfoForInboundPictureVo1 {
    /**
     * 商品id
     * @type {string}
     * @memberof GoodsInfoOrderInfoForInboundPictureVo1
     */
    goodsId?: string;
    /**
     * 订单号
     * @type {string}
     * @memberof GoodsInfoOrderInfoForInboundPictureVo1
     */
    orderCode?: string;
    /**
     * 接收人
     * @type {string}
     * @memberof GoodsInfoOrderInfoForInboundPictureVo1
     */
    receiver?: string;
    /**
     * 商品数量
     * @type {number}
     * @memberof GoodsInfoOrderInfoForInboundPictureVo1
     */
    goodsCode?: number;
    /**
     * 商品图片
     * @type {string}
     * @memberof GoodsInfoOrderInfoForInboundPictureVo1
     */
    goodsImg?: string;
    /**
     * 颜色颜色
     * @type {string}
     * @memberof GoodsInfoOrderInfoForInboundPictureVo1
     */
    color?: string;
    /**
     * 尺寸
     * @type {string}
     * @memberof GoodsInfoOrderInfoForInboundPictureVo1
     */
    size?: string;
    /**
     * 数量
     * @type {number}
     * @memberof GoodsInfoOrderInfoForInboundPictureVo1
     */
    quantity?: number;
    /**
     * 商品状态
     * @type {string}
     * @memberof GoodsInfoOrderInfoForInboundPictureVo1
     */
    goodsStatusName?: string;
}

/**
 * Check if a given object implements the GoodsInfoOrderInfoForInboundPictureVo1 interface.
 */
export function instanceOfGoodsInfoOrderInfoForInboundPictureVo1(value: object): value is GoodsInfoOrderInfoForInboundPictureVo1 {
    return true;
}

export function GoodsInfoOrderInfoForInboundPictureVo1FromJSON(json: any): GoodsInfoOrderInfoForInboundPictureVo1 {
    return GoodsInfoOrderInfoForInboundPictureVo1FromJSONTyped(json, false);
}

export function GoodsInfoOrderInfoForInboundPictureVo1FromJSONTyped(json: any, ignoreDiscriminator: boolean): GoodsInfoOrderInfoForInboundPictureVo1 {
    if (json == null) {
        return json;
    }
    return {
        
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'receiver': json['receiver'] == null ? undefined : json['receiver'],
        'goodsCode': json['goodsCode'] == null ? undefined : json['goodsCode'],
        'goodsImg': json['goodsImg'] == null ? undefined : json['goodsImg'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'goodsStatusName': json['goodsStatusName'] == null ? undefined : json['goodsStatusName'],
    };
}

export function GoodsInfoOrderInfoForInboundPictureVo1ToJSON(json: any): GoodsInfoOrderInfoForInboundPictureVo1 {
    return GoodsInfoOrderInfoForInboundPictureVo1ToJSONTyped(json, false);
}

export function GoodsInfoOrderInfoForInboundPictureVo1ToJSONTyped(value?: GoodsInfoOrderInfoForInboundPictureVo1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goodsId': value['goodsId'],
        'orderCode': value['orderCode'],
        'receiver': value['receiver'],
        'goodsCode': value['goodsCode'],
        'goodsImg': value['goodsImg'],
        'color': value['color'],
        'size': value['size'],
        'quantity': value['quantity'],
        'goodsStatusName': value['goodsStatusName'],
    };
}

